import { Injectable, inject } from '@angular/core';
import { AppGlobalService } from './app.global.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class FsService {
  private appGlobalService = inject(AppGlobalService);
  private utilService = inject(UtilService);

  public getConfig() {
    let config: any = {};
    const request = new XMLHttpRequest();
    if (this.appGlobalService.get('environmentInfo')) {
      const res = this.appGlobalService.get('environmentInfo');
      window['envInfo'] = res?.envInfo || {};
      if (res?.envInfo?.realtime_db_config) {
        config = res.envInfo.realtime_db_config;
      }
      config.persistance = true;
      return config;
    }
    try {
      request.open('GET', 'rest/v1/environmentinfo', false); // `false` makes the request synchronous
      request.withCredentials = true;
      request.setRequestHeader('x-rappit-application', this.appGlobalService.get('appId'));
      request.setRequestHeader('x-rappit-organization', this.appGlobalService.get('orgId'));

      const csrfToken = this.utilService.getCookie('XSRF-TOKEN');
      if (csrfToken) {
        request.setRequestHeader('XSRF-TOKEN', csrfToken);
      }

      request.send(null);

      if (request.status === 200) {
        const res = JSON.parse(request.responseText);
        this.appGlobalService.write('environmentInfo', res);
        window['envInfo'] = res?.envInfo || {};
        if (res?.envInfo?.realtime_db_config) {
          config = res.envInfo.realtime_db_config;
        }
      } else if (request.status === 401) {
        localStorage.removeItem('auth');
        location.reload();
      }
      //config.persistance = false;
      return config;
    } catch (e) {
      console.error('environment:getConfig: unable to get api key : ', e);
      if (!sessionStorage.getItem('envInfoFetchAgain')) {
        sessionStorage.setItem('envInfoFetchAgain', 'true');
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        sessionStorage.removeItem('envInfoFetchAgain');
      }
    }
  }
}
